import React, { useState, useRef, useEffect } from 'react';
import { useCountry } from '../context/CountryContext';
import './CountrySelector.css';

export default function CountrySelector() {
  const { country, setCountry, countries } = useCountry();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = countries.find((c) => c.code === country) || countries[0];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="country-selector" ref={ref}>
      <button className="country-selector-trigger" onClick={() => setOpen((o) => !o)}>
        <span className="country-flag">{current.flag}</span>
        <span className="country-label">{current.label}</span>
        <svg width="10" height="10" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      {open && (
        <div className="country-selector-menu">
          {countries.map((c) => (
            <button
              key={c.code}
              className={`country-selector-item${c.code === country ? ' active' : ''}`}
              onClick={() => {
                setCountry(c.code);
                setOpen(false);
              }}
            >
              <span className="country-flag">{c.flag}</span>
              {c.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
